import { clsx } from "clsx";
import { twMerge } from "tailwind-merge";

/**
 * Utility function to merge Tailwind CSS classes
 * @param {...string} inputs - Class names to merge
 * @returns {string} Merged class names
 */
export function cn(...inputs) {
  return twMerge(clsx(inputs));
}

/**
 * Common responsive design patterns for consistent spacing
 */
export const spacing = {
  section: "py-12 sm:py-16 lg:py-20 xl:py-24",
  container: "max-w-4xl mx-auto px-4 sm:px-6 lg:px-12",
  containerWide: "max-w-6xl mx-auto px-4 sm:px-6 lg:px-12",
  gap: "gap-6 sm:gap-8 lg:gap-12",
  mb: "mb-6 sm:mb-8 lg:mb-12",
};

/**
 * Common animation patterns
 */
export const animations = {
  fadeInUp: {
    initial: { opacity: 0, y: 25 },
    whileInView: { opacity: 1, y: 0 },
    viewport: { once: true },
    transition: { duration: 0.5 }
  },
  fadeIn: {
    initial: { opacity: 0 },
    whileInView: { opacity: 1 },
    viewport: { once: true },
    transition: { duration: 0.5 }
  },
  scaleOnHover: {
    whileHover: { scale: 1.05 },
    transition: { duration: 0.3 }
  }
};

/**
 * Common color patterns
 */
export const colors = {
  primary: "text-accent hover:text-accentHover",
  secondary: "text-secondary hover:text-secondary/80",
  muted: "text-slate",
  light: "text-lightSlate",
  lightest: "text-lighterSlate",
  border: "border-accent",
  bg: "bg-navy",
  bgLight: "bg-lightNavy",
  accent: "bg-accent/10 hover:bg-accent/20",
};